module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"remove":"Deletar","upload-personal":"Escolher selfie","upload-organization":"Escolher imagem"}}')
  delete Component.options._Ctor
}
